import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import reportStyle from 'styles.scss';
import S from 'styles/table.scss';
import { urls } from 'helpers/url';
import { Link } from 'react-router';
import { Checkbox, FontIcon } from 'react-toolbox';
import styles from 'styles/form';
import RTCheckbox from 'styles/checkbox.scss';

export default class TagsBulkExportTable extends React.Component {

  componentDidUpdate = () => {
    // only true if no tags in state are checked
    const noTagsChecked = this.props.tags.every(t => t.isChecked === false);
    // If no tags are checked, do not show the print button
    // If any tags are checked, show the print button
    if (noTagsChecked === true && this.props.showPrint) this.props.toggleShowPrint(false);
  }

  render = () => {
    const { tags, checkedAll } = this.props;
    return (<table
      className={`${S.cardTable} ${reportStyle.table}`}
      cellSpacing="0"
    >
      <thead>
        <tr className={S.headerRow}>
          <th className={S.column}>
            <Checkbox
              key="checkAll"
              checked={checkedAll}
              label="Select/Unselect all"
              onChange={() => this.props.handleToggleAll()}
              className={styles.checkboxListItem}
              theme={RTCheckbox}
            />
          </th>
          <th className={S.column}>PO #</th>
          <th className={S.column}>Customer Name</th>
          <th className={S.column}>Store #</th>
          <th className={S.column}>Item Name</th>
          <th className={S.column}>Quantity</th>
          <th className={S.column}>Tag #</th>
          <th className={S.column}>Date Received</th>
          <th className={S.column}>Bin</th>
        </tr>
      </thead>
      <tbody>
        {tags.map(tag => <tr key={tag.id} className={S.contentRow}>
          <td className={S.column}>
            <Checkbox
              checked={tag.isChecked}
              label={<FontIcon className={S.icon} value="ic_print" />}
              onChange={() => this.props.handleChange(tag)}
              className={styles.checkboxListItem}
              theme={RTCheckbox}
            />
          </td>
          <td className={S.column}>
            <Link
              to={urls.phasePurchaseOrders(tag.phase_id)}
              className={reportStyle.link}
              target="_blank"
            >
              {tag.purchase_order_number || 'N/A'}
            </Link>
          </td>
          <td className={S.column}>
            <Link
              to={urls.phaseWarehouseMaterials(tag.phase_id)}
              className={reportStyle.link}
              target="_blank"
            >
              {tag.customer_name || 'N/A'}
            </Link>
          </td>
          <td className={S.column}>
            {tag.store_number || 'N/A'}
          </td>
          <td className={S.column}>
            {tag.item_name || 'N/A'}
          </td>
          <td className={S.column}>
            {Math.floor(tag.received_quantity) || 'N/A'}
          </td>
          <td className={S.column}>
            {tag.tag_number || 'N/A'}
          </td>
          <td className={S.column}>
            <div>{moment(tag.date_received).format('MM/DD/YYYY')}</div>
          </td>
          <td className={S.column}>{tag.bin}</td>
        </tr>)}
      </tbody>
    </table>);
  }
}

TagsBulkExportTable.propTypes = {
  tags: PropTypes.array.isRequired,
  toggleShowPrint: PropTypes.func.isRequired,
  showPrint: PropTypes.bool.isRequired,
  checkedAll: PropTypes.bool.isRequired,
  handleToggleAll: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/tags/components/TagsBulkPrintTable/index.jsx